module.exports = __webpack_public_path__ + "media/application/images/svgs/bell-off-d99e40aeb2b4100d1a57d22ef9da3db6.svg";